import React, { FC, ReactNode } from 'react';
import { Page } from 'components/molecules/page';

const {
  Header: { Title: PageTitle },
} = Page;

interface Props {
  icon: ReactNode;
}

export const Title: FC<Props> = ({ icon, children }) => (
  <PageTitle>
    <PageTitle.Icon>{icon}</PageTitle.Icon>
    <PageTitle.Text>{children}</PageTitle.Text>
  </PageTitle>
);
